import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.sms-user-otp', {
        url: '/smsuserotp',
        component: 'smsUserOtp',
        params: {
        	showResetPinSuccessMessage: false
        }
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/sms-user-otp/sms-user-otp.state.js